import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { PageBase } from "../../../Components/PageBase";
import { useRol } from '../../../Context';
import Modal from "../../../Components/Modal";
import "./PerfilContacto.css";
import back from "../../../icons/arrow-back.svg";
import mail from "../../../icons/mail-outline.svg";
import phone from "../../../icons/call.svg"
import iconSvg from '../../../icons/add-circle.svg';
import img2 from "../../../icons/calendar-number-outline.svg";
import repeat from "../../../icons/repeat.svg";
import repeat2 from '../../../icons/repeat (1).svg';
import checkmark from '../../../icons/checkmark.svg';
import checkmark2 from '../../../icons/checkmark (1).svg';
import personTask from '../../../icons/person-sharp (1).svg';
import logoWhatsApp from '../../../icons/logo-whatsapp.svg';
import avatar from '../../../icons/avatar.png';
import edit from '../../../icons/pencil-sharp.svg';
import descart from '../../../icons/ban-sharp.svg';
import eliminar from '../../../icons/trash-sharp.svg';
import feliz from "../../../icons/emoji-feliz.png";
import serio from "../../../icons/emoji-serio.png";
import triste from "../../../icons/emoji-triste.png";
import congelado from "../../../icons/emoji-congelado.png";

function PerfilContacto() {
    const {
        rol,
        dataLead,
        setDataLead,
        age,
        setValorSelect1,
        marital_status,
        setValorSelect2,
        life_status,
        setValorSelect3,
        gender,
        setValorSelect4,
        purchase_reason,
        setValorSelect5,
        purchase_time,
        setValorSelect6,
        budget,
        setValorSelect7,
        payment_type,
        setValorSelect8,
        origin,
        setValorSelect9,
        contact_type,
        setValorSelect10,
        tag,
        setValorSelect11,
        city,
        setValorInput1,
        postulation_date,
        setValorInput2,
        visited_date,
        setValorInput3,
        handlePatchRequest,
        candidate_name,
        setCandidate_Name,
        email,
        setEmail,
        phone_number,
        setPhone_Number,
        second_phone_number,
        setSecond_Phone_Number,
        second_email,
        setSecond_Email,
        handlePatch2Request,
        title,
        setTitle,
        dataProfile,
        description,
        setDescription,
        expiration,
        setExpiration,
        handlePosthTasksByLeadRequest,
        tasksOpen,
        tasksFinished,
        setIdTask,
        task,
        setTask_Status,
        handlePatchTasksRequest,
        setTasksOpen,
        setTasksFinished,
        handleClickFinalizada,
        handleClickProceso,
        newTitle,
        setNewTitle,
        newObservation,
        setNewObservation,
        handleNotesCreate,
        userName,
        idLead,
        handlePatchDiscard,
        contracting_status,
        review_date,
        type_task,
        tasksByLeadOpen,
        tasksByLeadFinish,
        intentos,
        historial,
        image,
    } = useRol();

    const navigate = useNavigate();

    const [seleccionado, setSeleccionado] = useState("perfil");

    const cambiarSeleccion = (opcion) => {
        setSeleccionado(opcion);
    };

    function formatDateToLongDate(dateString) {
        if (!dateString) {
            return 'Fecha inválida';
        }
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };
        return new Date(dateString).toLocaleDateString('es-MX', options);
    }


    const [enModoEdicion, setEnModoEdicion] = useState(false);

    const activarEdicion = () => {
        setEnModoEdicion(true);
    }

    const cancelarEdicion = () => {
        setEnModoEdicion(false);
    }

    const estiloSelect = {
        appearance: enModoEdicion ? 'auto' : 'none',
    };

    const [activeTab, setActiveTab] = useState('pendientes');

    // Modal **WEB** agregar tareas perfil contacto
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** tareas pendientes perfil contacto
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const openModal2 = (taskId) => {
        setIdTask(taskId)
        setIsModalOpen2(true);

    };
    const closeModal2 = (task) => {
        setTasksOpen(tasksOpen.filter(item => item !== task));
        setTasksFinished([...tasksFinished, task]);
        setIsModalOpen2(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** tareas finalizadas perfil contacto
    const [isModalOpen3, setIsModalOpen3] = useState(false);
    const openModal3 = (taskId) => {
        setIdTask(taskId)
        setIsModalOpen3(true);
    };
    const closeModal3 = (task) => {
        setTasksFinished(tasksFinished.filter(item => item !== task));
        setTasksOpen([...tasksOpen, task]);
        setIsModalOpen3(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **WEB** descartar lead en perfil contacto
    const [isModalOpen4, setIsModalOpen4] = useState(false);
    const openModal4 = () => {
        setIsModalOpen4(true);
    };
    const closeModal4 = () => {
        setTitle('')
        setNewObservation('')
        setIsModalOpen4(false);
        document.body.style.overflow = 'visible';
    };

    const [mostrarNuevoDiv, setMostrarNuevoDiv] = useState(false);

    const mostrarDiv = () => {
        setMostrarNuevoDiv(true);
    };

    const [mostrarDiv2, setMostrarDiv2] = useState(false);

    const toggleDiv = () => {
        setMostrarDiv2(!mostrarDiv2);
    };

    // Modal **MOVIL** agregar tarea
    const [isModalOpenAddTarea, setIsModalOpenAddTarea] = useState(false);
    const openModalAddTarea = () => {
        setIsModalOpenAddTarea(true);
    };
    const closeModalAddTarea = () => {
        setIsModalOpenAddTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** tareas pendientes
    const [isModalOpenPendientTarea, setIsModalOpenPendientTarea] = useState(false);
    const openModalPendientTarea = (taskId) => {
        setIdTask(taskId)
        setIsModalOpenPendientTarea(true);
    };
    const closeModalPendientTarea = (task) => {
        setTasksOpen(tasksOpen.filter(item => item !== task));
        setTasksFinished([...tasksFinished, task]);
        setIsModalOpenPendientTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** tareas finalizadas
    const [isModalOpenFinishTarea, setIsModalOpenFinishTarea] = useState(false);
    const openModalFinishTarea = (taskId) => {
        setIdTask(taskId)
        setIsModalOpenFinishTarea(true);
    };
    const closeModalFinishTarea = (task) => {
        setTasksFinished(tasksFinished.filter(item => item !== task));
        setTasksOpen([...tasksOpen, task]);
        setIsModalOpenFinishTarea(false);
        document.body.style.overflow = 'visible';
    };

    // Modal **MOVIL** crear nota
    const [isModalOpenNota, setIsModalOpenNota] = useState(false);
    const openModalNota = () => {
        setIsModalOpenNota(true);
    };
    const closeModalNota = () => {
        setIsModalOpenNota(false);
        document.body.style.overflow = 'visible';
    };


    let nombre = dataLead ? dataLead.candidate_name : "▒";
    let user = dataProfile ? dataProfile.first_name : "User";
    let nombreCompleto = dataProfile ? dataProfile.first_name + " " + dataProfile.last_name : "User"

    const ocultarDiv = () => {
        setMostrarNuevoDiv(false);
    };

    useEffect(() => {
        if (!mostrarNuevoDiv) {
            const textElements = document.querySelectorAll('.img-profile-perfilContacto');
            textElements.forEach((element) => {
                const text = element.textContent;
                const firstLetter = document.createElement('span');
                firstLetter.className = 'primera-letra';
                firstLetter.textContent = text[0];
                element.textContent = '';
                element.appendChild(firstLetter);
            });
        }
    }, [mostrarNuevoDiv]);


    useEffect(() => {
        if (nombre === null) {
            setDataLead();
        }
        const textElements = document.querySelectorAll('.img-profile-perfilContacto');
        textElements.forEach((element) => {
            const text = element.textContent;
            const firstLetter = document.createElement('span');
            firstLetter.className = 'primera-letra';
            firstLetter.textContent = text[0];
            element.textContent = '';
            element.appendChild(firstLetter);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nombre]);

    useEffect(() => {
        const textElements = document.querySelectorAll('.cuadrado');
        textElements.forEach((element) => {
            const text = element.textContent;
            const firstLetter = document.createElement('span');
            firstLetter.className = 'inicial';
            firstLetter.textContent = text[0];
            element.textContent = '';
            element.appendChild(firstLetter);
        });
    }, [idLead, isModalOpenAddTarea, isModalOpenFinishTarea, isModalOpenPendientTarea]);

    useEffect(() => {
        if (isModalOpen) {
            const textElements = document.querySelectorAll('.cuadrado');
            textElements.forEach((element) => {
                const text = element.textContent;
                const firstLetter = document.createElement('span');
                firstLetter.className = 'inicial';
                firstLetter.textContent = text[0];
                element.textContent = '';
                element.appendChild(firstLetter);
            });
        }
    }, [isModalOpen]);

    useEffect(() => {
        setCandidate_Name(dataLead ? dataLead.candidate_name : "Cargando..")
        setEmail(dataLead ? dataLead.email : "Cargando...")
        setPhone_Number(dataLead ? dataLead.phone_number : "Cargando...")
        setValorSelect1(dataLead ? dataLead.age : 'No estoy seguro')
        setValorSelect2(dataLead ? dataLead.marital_status : 'Sin respuesta')
        setValorInput1(dataLead ? dataLead.city : 'Sin respuesta')
        setValorSelect3(dataLead ? dataLead.life_status : 'Sin respuesta')
        setValorSelect4(dataLead ? dataLead.gender : 'Sin respuesta')
        setValorSelect5(dataLead ? dataLead.purchase_reason : 'Sin respuesta')
        setValorSelect6(dataLead ? dataLead.purchase_time : 'No estoy seguro')
        setValorSelect7(dataLead ? dataLead.budget : 'Sin respuesta')
        setValorSelect8(dataLead ? dataLead.payment_type : 'Sin respuesta')
        setValorSelect9(dataLead ? dataLead.origin : 'Base de Datos')
        setValorSelect10(dataLead ? dataLead.contact_type : '')
        setValorSelect11(dataLead ? dataLead.tag : 'Sin etiqueta')
        setValorInput2(dataLead ? dataLead.postulation_date.split('T')[0] : '')
        setValorInput3(dataLead ? dataLead.visited_date ? formatDateToLongDate(dataLead.visited_date) : 'Sin visita' : '')
    }, [
        dataLead,
        setValorInput1,
        setValorInput2,
        setValorInput3,
        setValorSelect1,
        setValorSelect10,
        setValorSelect11,
        setValorSelect2,
        setValorSelect3,
        setValorSelect4,
        setValorSelect5,
        setValorSelect6,
        setValorSelect7,
        setValorSelect8,
        setValorSelect9,
        setCandidate_Name,
        setEmail,
        setPhone_Number
    ]);

    useEffect(() => {
        setTitle(task ? task.title : '')
        setExpiration(task ? task.expiration : null)
        setDescription(task ? task.description : '')
    }, [task, setTitle, setExpiration, setDescription])

    const handleDateChange = (event) => {
        const inputDate = event.target.value;

        const formattedDate = formatInputDate(inputDate);

        setValorInput2(formattedDate);
    };

    const formatInputDate = (inputDate) => {
        const dateObject = new Date(inputDate);

        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
        const hours = dateObject.getHours().toString().padStart(2, '0');
        const minutes = dateObject.getMinutes().toString().padStart(2, '0');
        const seconds = dateObject.getSeconds().toString().padStart(2, '0')
        const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        return formattedDate;
    };

    const handleDate2Change = (e) => {
        const selectedDate = e.target.value;
        const adjustedDate = new Date(selectedDate + 'T00:00:00Z');
        const formattedDate = formatDate(adjustedDate);
        setExpiration(formattedDate);
    };

    const formatDate = (dateObject) => {
        const year = dateObject.getUTCFullYear();
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
        const day = String(dateObject.getUTCDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const formatDateNotas = (dateString) => {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();

        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');

        const formattedDate = `${day} de ${month} de ${year} a las ${hours}:${minutes}`;

        return formattedDate;
    }

    const resetInputs = () => {
        setNewTitle('');
        setNewObservation('');
    };

    const handleOpcionChange = (event) => {
        setNewObservation(event.target.value);
    };

    const convertirFecha = (fecha) => {
        const fechaObjeto = new Date(fecha);
        const opcionesFormato = { day: 'numeric', month: 'short', year: 'numeric' };
        const fechaFormateada = fechaObjeto.toLocaleDateString('es-MX', opcionesFormato);
        return fechaFormateada;
    };

    function calculateDateDifference(reviewDate) {
        const currentDate = new Date();
        const lastContactDate = new Date(reviewDate);
        const differenceInDays = Math.floor((currentDate - lastContactDate) / (1000 * 60 * 60 * 24));
        return differenceInDays;
    }

    function getEmojiImage(differenceInDays) {
        if (differenceInDays >= 0 && differenceInDays <= 6) {
            return feliz;
        } else if (differenceInDays >= 7 && differenceInDays <= 13) {
            return serio;
        } else if (differenceInDays >= 14 && differenceInDays <= 21) {
            return triste;
        } else {
            return congelado;
        }
    }

    const [page, setPage] = useState(1);
    const itemsPerPage = 3;

    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const handlePreviousPage = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            duration: 1000
        });
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextPage = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            duration: 1000
        });
        const maxPage = Math.ceil(intentos?.length / itemsPerPage);
        if (page < maxPage) {
            setPage(page + 1);
        }
    };

    const maxPage = Math.ceil(intentos?.length / itemsPerPage);

    //Historial

    const [pageHistory, setPageHistory] = useState(1);
    const itemsPerPageHistory = 7;

    const startIndexHistory = (pageHistory - 1) * itemsPerPageHistory;
    const endIndexHistory = startIndexHistory + itemsPerPageHistory;

    const handlePreviousPageHistory = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            duration: 1000
        });
        if (pageHistory > 1) {
            setPageHistory(pageHistory - 1);
        }
    };

    const handleNextPageHistory = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            duration: 1000
        });
        const maxPageHistory = Math.ceil(historial?.length / itemsPerPageHistory);
        if (pageHistory < maxPageHistory) {
            setPageHistory(pageHistory + 1);
        }
    };

    const maxPageHistory = Math.ceil(historial?.length / itemsPerPageHistory);

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="margenes-generales-perfilContacto">
                    <div className="contenedor-principal-perfilContacto">
                        <div className="apartado-perfil-perfilContacto">
                            <NavLink to={'/Contactos'} className="nav-links">
                                <div className="button-back-perfilContacto">
                                    <img src={back} alt="back" />
                                    <label>Regresar a tablero de contactos</label>
                                </div>
                            </NavLink>
                            <div className="data-profile-perfilContacto">
                                {mostrarNuevoDiv ? null : <div className="data-profile-perfilContacto">
                                    <div className="img-profile-perfilContacto">
                                        {nombre}
                                    </div>
                                    <div className="name-profile-perfilContacto">
                                        <label>{candidate_name}</label>
                                    </div>
                                    <div className="email-profile-perfilContacto">
                                        <img src={mail} alt="" />
                                        <label>{email}</label>
                                    </div>
                                    <div className="phone-profile-perfilContacto">
                                        <img src={phone} alt="" />
                                        <label>{phone_number}</label>
                                    </div>
                                </div>}
                                {mostrarNuevoDiv && (
                                    <div className="data-edit-profile-perfilContacto">
                                        <input value={candidate_name} onChange={(e) => setCandidate_Name(e.target.value)} />
                                        <input value={email} onChange={(e) => setEmail(e.target.value)} />
                                        <input value={second_email} onChange={(e) => setSecond_Email(e.target.value)} placeholder="Correo electrónico Secundario" />
                                        <input value={phone_number} onChange={(e) => setPhone_Number(e.target.value)} />
                                        <input value={second_phone_number} onChange={(e) => setSecond_Phone_Number(e.target.value)} placeholder="Teléfono Secundario" />
                                        <div className="buttons-edit-profile-perfilContacto">
                                            <button id="acept" onClick={() => {
                                                handlePatch2Request()
                                                setTimeout(() => {
                                                    ocultarDiv();
                                                }, 1000);
                                            }}>Aceptar</button>
                                            <button id="cancel" onClick={ocultarDiv}>Cancelar</button>
                                        </div>
                                    </div>
                                )}
                                <div className="afinidad-interes-probable-perfilContacto">
                                    <div className="row-afinpro-perfilContacto">
                                        <div className="col-afinpro-perfilContacto">
                                            <span>{dataLead ? dataLead.affinity : 50}%</span>
                                            <label>Afinidad</label>
                                        </div>
                                        <div className="col-afinpro-perfilContacto">
                                            <span>{dataLead ? dataLead.interest : 100}%</span>
                                            <label>Interés</label>
                                        </div>
                                    </div>
                                </div>
                                {rol === 'Asesor' && <div className="buttons-profile-perfilContacto">
                                    <div className="row-buttons-perfilContacto">
                                        <div className="col-buttons-asesor-perfilContacto">
                                            <button onClick={mostrarDiv}>Editar</button>
                                        </div>
                                        <div className="col-buttons-asesor-perfilContacto">
                                            <button onClick={openModal4}>Descartar</button>
                                        </div>
                                    </div>
                                </div>}
                                {rol === 'Coordinador' && <div className="buttons-profile-perfilContacto">
                                    <div className="row-buttons-perfilContacto">
                                        <div className="col-buttons-perfilContacto">
                                            <button onClick={mostrarDiv}>Editar</button>
                                        </div>
                                        <div className="col-buttons-perfilContacto">
                                            <button onClick={openModal4}>Descartar</button>
                                        </div>
                                        <div className="col-buttons-perfilContacto">
                                            <button>Eliminar</button>
                                        </div>
                                    </div>
                                </div>}
                                <div className="menu-profile-perfilContacto">
                                    <div className={`opcion ${seleccionado === "perfil" ? "seleccionado" : ""}`} onClick={() => cambiarSeleccion("perfil")}>
                                        Datos de perfil
                                    </div>
                                    <div className={`opcion ${seleccionado === "tareas" ? "seleccionado" : ""}`} onClick={() => cambiarSeleccion("tareas")}>
                                        Tareas programadas
                                    </div>
                                    <div className={`opcion ${seleccionado === "contacto" ? "seleccionado" : ""}`} onClick={() => cambiarSeleccion("contacto")}>
                                        Intentos de contacto
                                    </div>
                                    <div className={`opcion ${seleccionado === "historial" ? "seleccionado" : ""} sin`} onClick={() => cambiarSeleccion("historial")}>
                                        Historial de acciones
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="apartado-info-perfilContacto">
                            {seleccionado === "perfil" && <div className="info-margen-perfilContacto">
                                <div className="title-profile-info-perfilContacto">
                                    <label>Información del prospecto</label>
                                </div>
                                <div className="container-lead-perfilContacto perfilContacto-second">
                                    <div className="label-lead-modal">
                                        <label>Edad</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={age}
                                            onChange={(e) => setValorSelect1(e.target.value)}>
                                            <option value="No estoy seguro">No estoy seguro</option>
                                            <option value="18 a 20">18 a 20</option>
                                            <option value="21 a 25">21 a 25</option>
                                            <option value="26 a 30">26 a 30</option>
                                            <option value="31 a 35">31 a 35</option>
                                            <option value="36 a 40">36 a 40</option>
                                            <option value="41 a 45">41 a 45</option>
                                            <option value="46 a 50">46 a 50</option>
                                            <option value="51 a 55">51 a 55</option>
                                            <option value="Mas de 60">Más de 60</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Estado civil</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={marital_status}
                                            onChange={(e) => setValorSelect2(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="Soltero">Soltero</option>
                                            <option value="Casado">Casado</option>
                                            <option value="Divorciado">Divorciado</option>
                                            <option value="Viudo">Viudo</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Lugar de residencia</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <input placeholder="Sin respuesta" type="text"
                                            disabled={!enModoEdicion}
                                            value={city}
                                            onChange={(e) => setValorInput1(e.target.value)} />
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Etapa de vida</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={life_status}
                                            onChange={(e) => setValorSelect3(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="Joven soltero">Joven soltero (21-35)</option>
                                            <option value="Adulto soltero (36+)">Adulto soltero (36+)</option>
                                            <option value="Sin hijos">Sin hijos</option>
                                            <option value="Familia pequeña (Hijos de 0-10)">Familia pequeña (Hijos de 0-10)</option>
                                            <option value="Familia joven (Hijos de 11-20)">Familia joven (Hijos de 11-20)</option>
                                            <option value="Familia grande (21+)">Familia grande (21+)</option>
                                            <option value="Divorciado con hijos (21+)">Divorciado con hijos (21+)</option>
                                            <option value="Adulto mayor (51+)">Adulto mayor (51+)</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Género</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={gender}
                                            onChange={(e) => setValorSelect4(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="Hombre">Hombre</option>
                                            <option value="Mujer">Mujer</option>
                                            <option value="No Binario">No Binario</option>
                                            <option value="No definido">No definido</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Rázon de compra</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={purchase_reason}
                                            onChange={(e) => setValorSelect5(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="Vivir">Vivir</option>
                                            <option value="Renta">Renta</option>
                                            <option value="Inversion">Inversión</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Tiempo de compra</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={purchase_time}
                                            onChange={(e) => setValorSelect6(e.target.value)}>
                                            <option value="No estoy seguro">No estoy seguro</option>
                                            <option value="Tres meses">Tres meses</option>
                                            <option value="Seis meses">Seis meses</option>
                                            <option value="Un año">Un año</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Presupuesto aproximado</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={budget}
                                            onChange={(e) => setValorSelect7(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="$400,000 a $490,000">$400,000 a $490,000</option>
                                            <option value="$500,000 a $780,000">$500,000 a $780,000</option>
                                            <option value="$790,000 a $890,000">$790,000 a $890,000</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Forma de pago</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={payment_type}
                                            onChange={(e) => setValorSelect8(e.target.value)}>
                                            <option value="Sin respuesta">Sin respuesta</option>
                                            <option value="Contado Riguroso">Contado Riguroso</option>
                                            <option value="Contado Plazo">Contado Plazo</option>
                                            <option value="Crédito Infonavit">Crédito Infonavit</option>
                                            <option value="Crédito Interno">Crédito Interno</option>
                                            <option value="Crédito Bancario">Crédito Bancario</option>
                                            <option value="Credito Hipotecario">Credito Hipotecario</option>
                                            <option value="Fovissste">Fovissste</option>
                                            <option value="Fovissste Aliados">Fovissste Aliados</option>
                                            <option value="Fovissste Para Todos">Fovissste Para Todos</option>
                                            <option value="Infonavit Total">Infonavit Total</option>
                                            <option value="Apoyo Infonavit">Apoyo Infonavit</option>
                                            <option value="Cofinavit">Cofinavit</option>
                                            <option value="CFE">CFE</option>
                                            <option value="Telmex">Telmex</option>
                                            <option value="Cofinanciamiento">Cofinanciamiento</option>
                                            <option value="Cajas de Ahorro">Cajas de Ahorro</option>
                                            <option value="Otro">Otro</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Origen de prospecto</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={origin}
                                            onChange={(e) => setValorSelect9(e.target.value)}>
                                            <optgroup label="Medios Digitales">
                                                <option value="Base_Datos">Base de Datos</option>
                                                <option value="Facebook">Facebook</option>
                                                <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                                <option value="Google">Google</option>
                                                <option value="Instagram">Instagram</option>
                                                <option value="Whatsapp">Whatsapp</option>
                                                <option value="Tiktok">Tiktok</option>
                                                <option value="Página web">Pagina web</option>
                                                <option value="Redes sociales">Redes sociales</option>
                                            </optgroup>
                                            <optgroup label="Medios Tradicionales">
                                                <option value="Broker">Broker o Asesor Externo</option>
                                                <option value="Cambaceo">Cambaceo</option>
                                                <option value="Contacto Directo">Contacto Directo</option>
                                                <option value="Espectacular">Espectacular</option>
                                                <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                                <option value="Lonas">Lonas</option>
                                                <option value="Periodico">Periodico</option>
                                                <option value="Radio">Radio</option>
                                                <option value="Recompra">Recompra</option>
                                                <option value="Revista">Revista</option>
                                                <option value="Referidos">Referidos</option>
                                                <option value="Señaletica">Señaletica</option>
                                                <option value="Telefono">Telefono</option>
                                                <option value="Televisión">Televisión</option>
                                                <option value="Volante">Volante</option>
                                                <option value="Walk-in">Walk-in</option>
                                            </optgroup>
                                            <optgroup label="Portales Inmobiliarios">
                                                <option value="Inmuebles 24">Inmuebles 24</option>
                                                <option value="Lamudi">Lamudi</option>
                                                <option value="Metros cúbicos">Metros cúbicos</option>
                                                <option value="Propiedades.com">Propiedades.com</option>
                                                <option value="Segundamano">Segundamano</option>
                                                <option value="Tu Hogar México">Tu Hogar México</option>
                                                <option value="Vivanuncios">Vivanuncios</option>
                                            </optgroup>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Medio de contacto</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={contact_type}
                                            onChange={(e) => setValorSelect10(e.target.value)}>
                                            <option value="Teléfono">Teléfono</option>
                                            <option value="Correo">Correo</option>
                                            <option value="Whatsapp">Whatsapp</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Fecha de prospección</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <input type="date"
                                            disabled={!enModoEdicion}
                                            value={postulation_date}
                                            onChange={handleDateChange} />
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Último contacto</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <label>{formatDateToLongDate(dataLead ? dataLead.review_date : 'Cargando...')}</label>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Fecha de creación</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <label>{formatDateToLongDate(dataLead ? dataLead.created_date : 'Cargando...')}</label>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Etiqueta</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <select style={estiloSelect} disabled={!enModoEdicion}
                                            value={tag}
                                            onChange={(e) => setValorSelect11(e.target.value)}>
                                            <option value="Sin etiqueta">Sin etiqueta</option>
                                            <option value="Seguimiento">Seguimiento</option>
                                            <option value="Llamar más adelante">Llamar más adelante</option>
                                            <option value="No contesta">No contesta</option>
                                            <option value="Apartado">Apartado</option>
                                            <option value="No comprará">No comprará</option>
                                        </select>
                                    </div>
                                    <div className="label-lead-modal perfilContacto-second">
                                        <label>Visitó desarrollo</label>
                                    </div>
                                    <div className="input-date-lead-modal">
                                        <input type="text"
                                            disabled={!enModoEdicion}
                                            value={formatDateToLongDate(visited_date) || 'Sin visita'}
                                            onChange={(e) => setValorInput3(e.target.value)} />
                                    </div>
                                </div>
                                {enModoEdicion ? (
                                    <div>
                                        <div className="buttons-container-perfilContacto">
                                            <button className="btn-acept-modal" onClick={() => {
                                                handlePatchRequest()
                                                setTimeout(() => {
                                                    cancelarEdicion();
                                                }, 1000);
                                            }}>Guardar</button>
                                            <button className="btn-cancel-perfilContacto" onClick={cancelarEdicion}>Cancelar</button>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="buttons-container-perfilContacto">
                                        <button className="btn-acept-modal" onClick={activarEdicion}>Editar perfil</button>
                                    </div>
                                )}
                            </div>}
                            {seleccionado === "tareas" && <div className="info-margen-perfilContacto">
                                <div className="cabecera">
                                    <div className="add-boton">
                                        <button onClick={openModal}>
                                            <img src={iconSvg} alt="+" />
                                            <label>Añadir nueva tarea</label>
                                        </button>
                                    </div>
                                    <div className="container-filtrosTask">
                                        <div className={`tab ${activeTab === 'pendientes' ? 'active' : ''}`} onClick={() => setActiveTab('pendientes')}>
                                            <label>Pendientes</label>
                                        </div>
                                        <div className={`tab ${activeTab === 'finalizadas' ? 'active' : ''}`} onClick={() => setActiveTab('finalizadas')}>
                                            <label>Finalizadas</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-perfilContacto">
                                    {activeTab === 'pendientes' && <div className="container-pendientes">
                                        {tasksByLeadOpen && Array.isArray(tasksByLeadOpen) && tasksByLeadOpen.length > 0 ? (
                                            tasksByLeadOpen
                                                .sort((a, b) => new Date(b.expiration) - new Date(a.expiration))
                                                .map(task => (
                                                    <div className="task" onClick={() => openModal2(task.id)} key={task.id}>
                                                        <label className="name-task">{task.title}</label>
                                                        <label className="date-task"><small>{task.expiration}</small></label>
                                                        <label className="asesor-task"><small>{user}</small></label>
                                                    </div>
                                                ))) : (<div className="porlet-body">
                                                    <div className="margen">
                                                        <div className="porlet-label">
                                                            <h4>Sin tareas creadas</h4>
                                                            <p>Comienza crando una tarea</p>
                                                        </div>
                                                        <div className="porlet-image">
                                                            <img src={image} alt="vacants" />
                                                        </div>
                                                    </div>
                                                </div>)}
                                    </div>}
                                    {activeTab === 'finalizadas' && <div className="container-finalizadas">
                                        {tasksByLeadFinish && Array.isArray(tasksByLeadFinish) && tasksByLeadFinish.length > 0 ? (
                                            tasksByLeadFinish
                                                .sort((a, b) => new Date(b.expiration) - new Date(a.expiration))
                                                .map(task => (
                                                    <div className="task" onClick={() => openModal3(task.id)} key={task.id}>
                                                        <label className="name-task">{task.title}</label>
                                                        <label className="date-task"><small>{task.expiration}</small></label>
                                                        <label className="asesor-task"><small>{user}</small></label>
                                                    </div>
                                                ))) : (<div className="porlet-body">
                                                    <div className="margen">
                                                        <div className="porlet-label">
                                                            <h4>Sin tareas finalizadas</h4>
                                                            <p>Comienza finalizando una tarea</p>
                                                        </div>
                                                        <div className="porlet-image">
                                                            <img src={image} alt="vacants" />
                                                        </div>
                                                    </div>
                                                </div>)}
                                    </div>}
                                </div>
                            </div>}
                            {seleccionado === "contacto" && <div className="info-margen-perfilContacto">
                                <div className="title-profile-info-perfilContacto">
                                    <label>Intentos de contacto</label>
                                </div>
                                <div className="contacto-contenedor-perfilContacto">
                                    <label>Crea una nueva nota o alerta</label>
                                    <input
                                        placeholder="Titulo"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                    />
                                    <textarea
                                        rows="4"
                                        cols="40"
                                        placeholder="Detalles de la nota..."
                                        value={newObservation}
                                        onChange={(e) => setNewObservation(e.target.value)}
                                    ></textarea>
                                    <button onClick={() => {
                                        handleNotesCreate()
                                        resetInputs()
                                    }}>Crear nota</button>
                                </div>
                                <div className="container-notas-created">
                                    {(intentos && Array.isArray(intentos) && intentos.length > 0) ? (
                                        intentos?.sort((a, b) => new Date(b.created) - new Date(a.created))
                                            .slice(startIndex, endIndex)
                                            .map((notes) => (
                                                <div className="nota-creada" key={notes.id}>
                                                    <div className="nota-primeros-datos">
                                                        <img src={avatar} alt="avatar" />
                                                        <label className="notas-user">{userName}</label>
                                                        <label className="notas-date">{formatDateNotas(notes.created)}</label>
                                                    </div>
                                                    <div className="nota-segundos-datos">
                                                        <label className="notas-title">{notes.title}</label>
                                                        <label className="notas-observation">{notes.observation}</label>
                                                    </div>
                                                </div>
                                            ))
                                    ) : (
                                        <p className="sin-notas">* Por el momento no se ha creado ninguna nota para este prospecto.</p>
                                    )}
                                </div>
                                <div className="paginacion">
                                    {intentos?.length > itemsPerPage && page > 1 && (
                                        <button onClick={handlePreviousPage}>&lt; Anterior</button>
                                    )}
                                    <button>{page} de {maxPage}</button>
                                    {intentos?.length > itemsPerPage && page < maxPage && (
                                        <button onClick={handleNextPage}>Siguiente &gt;</button>
                                    )}
                                </div>
                            </div>}
                            {seleccionado === "historial" && <div className="info-margen-perfilContacto">
                                <div className="title-profile-info-perfilContacto">
                                    <label>Historial de acciones</label>
                                </div>
                                <div className="lista-historial-perfilContacto">
                                    {(historial && Array.isArray(historial) && historial.length > 0) ? (
                                        historial?.sort((a, b) => new Date(b.created) - new Date(a.created))
                                            .slice(startIndexHistory, endIndexHistory)
                                            .map((notes) => (
                                                <div className="nota-creada" key={notes.id}>
                                                    <div className="nota-primeros-datos">
                                                        <img className="img-history-avatar" src={avatar} alt="avatar" />
                                                        <label className="notas-user">{userName}</label>
                                                        <label className="notas-date">{formatDateNotas(notes.created)}</label>
                                                    </div>
                                                    <div className="nota-segundos-datos">
                                                        <label className="notas-title">{notes.title}</label>
                                                        <label className="notas-observation">{notes.observation}</label>
                                                    </div>
                                                </div>
                                            ))) : (
                                        <p className="sin-notas">* Por el momento no se puede obtener el historial de este prospecto.</p>
                                    )}
                                </div>
                                <div className="paginacion">
                                    {historial?.length > itemsPerPageHistory && pageHistory > 1 && (
                                        <button onClick={handlePreviousPageHistory}>&lt; Anterior</button>
                                    )}
                                    <button>{pageHistory} de {maxPageHistory}</button>
                                    {historial?.length > itemsPerPageHistory && pageHistory < maxPageHistory && (
                                        <button onClick={handleNextPageHistory}>Siguiente &gt;</button>
                                    )}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="perfilContacto-movil">
                <div className="container-main-movil">
                    <NavLink to={'/Contactos'} className="nav-links-movil">
                        <div className="button-back-perfilContacto-movil">
                            <img src={back} alt="back" />
                            <label>Regresar a tablero de contactos</label>
                        </div>
                    </NavLink>
                    <div className="lead-card-perfilContacto-movil">
                        <div className="container-data-lead-movil">
                            <div className="emoji-lead-perfilContacto-movil">
                                <span><img src={getEmojiImage(calculateDateDifference(review_date))} alt="" /></span>
                            </div>
                            <div className="data-lead-perfilContacto-movil">
                                <NavLink to={'/Perfil-de-contacto'} className="nav-links-movil">
                                    <label className="name-lead-movil">{candidate_name}</label>
                                </NavLink>
                                <label className="type-lead-movil">{contracting_status}</label>
                                <label className="date-lead-movil">{convertirFecha(review_date)}</label>
                            </div>
                            <div onClick={toggleDiv} className="icon-lead-perfilContacto-movil">
                                <img src={edit} alt="edit" />
                            </div>
                            <div onClick={openModal4} className="icon-lead-perfilContacto-movil">
                                <img src={descart} alt="descart" />
                            </div>
                            {rol === 'Coordinador' &&
                                <div className="icon-lead-perfilContacto-movil">
                                    <img src={eliminar} alt="eliminar" />
                                </div>
                            }
                        </div>
                        <div className="container-buttons-lead-movil">
                            <div className={`opcion ${seleccionado === "perfil" ? "seleccionado-movil" : ""} lead-detalles-perfilContacto-movil`} onClick={() => cambiarSeleccion("perfil")}>
                                <label>Perfil</label>
                            </div>
                            <div className={`opcion ${seleccionado === "tareas" ? "seleccionado-movil" : ""} lead-detalles-perfilContacto-movil`} onClick={() => cambiarSeleccion("tareas")}>
                                <label>Tareas</label>
                            </div>
                            <div className={`opcion ${seleccionado === "contacto" ? "seleccionado-movil" : ""} lead-detalles-perfilContacto-movil`} onClick={() => cambiarSeleccion("contacto")}>
                                <label>Intentos</label>
                            </div>
                            <div className={`opcion ${seleccionado === "historial" ? "seleccionado-movil" : ""} lead-detalles-perfilContacto-movil sin-movil`} onClick={() => cambiarSeleccion("historial")}>
                                <label>Historial</label>
                            </div>
                            {mostrarDiv2 && <div className="lead-detail-movil">
                                <div className="data-edit-profile-perfilContacto-movil">
                                    <input value={candidate_name} onChange={(e) => setCandidate_Name(e.target.value)} />
                                    <input value={email} onChange={(e) => setEmail(e.target.value)} />
                                    <input value={second_email} onChange={(e) => setSecond_Email(e.target.value)} placeholder="Correo electrónico Secundario" />
                                    <input value={phone_number} onChange={(e) => setPhone_Number(e.target.value)} />
                                    <input value={second_phone_number} onChange={(e) => setSecond_Phone_Number(e.target.value)} placeholder="Teléfono Secundario" />
                                    <div className="buttons-edit-profile-perfilContacto-movil">
                                        <button id="acept" onClick={() => {
                                            handlePatch2Request()
                                            setTimeout(() => {
                                                toggleDiv();
                                            }, 1000);
                                        }}>Aceptar</button>
                                        <button id="cancel" onClick={toggleDiv}>Cancelar</button>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                    {seleccionado === "perfil" && <div className="info-margen-perfilContacto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Información del prospecto</label>
                        </div>
                        <div className="container-lead-perfilContacto-movil">
                            <div className="label-lead-perfilContacto-movil">
                                <label>Edad</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={age}
                                    onChange={(e) => setValorSelect1(e.target.value)}>
                                    <option value="No estoy seguro">No estoy seguro</option>
                                    <option value="18 a 20">18 a 20</option>
                                    <option value="21 a 25">21 a 25</option>
                                    <option value="26 a 30">26 a 30</option>
                                    <option value="31 a 35">31 a 35</option>
                                    <option value="36 a 40">36 a 40</option>
                                    <option value="41 a 45">41 a 45</option>
                                    <option value="46 a 50">46 a 50</option>
                                    <option value="51 a 55">51 a 55</option>
                                    <option value="Más de 60">Más de 60</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Estado civil</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={marital_status}
                                    onChange={(e) => setValorSelect2(e.target.value)}>
                                    <option value="null">Sin respuesta</option>
                                    <option value="Soltero">Soltero</option>
                                    <option value="Casado">Casado</option>
                                    <option value="Divorciado">Divorciado</option>
                                    <option value="Viudo">Viudo</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Lugar de residencia</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <input placeholder="Sin respuesta" type="text"
                                    disabled={!enModoEdicion}
                                    value={city}
                                    onChange={(e) => setValorInput1(e.target.value)} />
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Etapa de vida</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={life_status}
                                    onChange={(e) => setValorSelect3(e.target.value)}>
                                    <option value="null">Sin respuesta</option>
                                    <option value="Joven soltero (21-35)">Joven soltero (21-35)</option>
                                    <option value="Adulto soltero (36+)">Adulto soltero (36+)</option>
                                    <option value="Sin hijos">Sin hijos</option>
                                    <option value="Familia pequeña (Hijos de 0-10)">Familia pequeña (Hijos de 0-10)</option>
                                    <option value="Familia joven (Hijos de 11-20)">Familia joven (Hijos de 11-20)</option>
                                    <option value="Familia grande (21+)">Familia grande (21+)</option>
                                    <option value="Divorciado con hijos (21+)">Divorciado con hijos (21+)</option>
                                    <option value="Adulto mayor (51+)">Adulto mayor (51+)</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Género</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={gender}
                                    onChange={(e) => setValorSelect4(e.target.value)}>
                                    <option value="null"></option>
                                    <option value="Hombre">Hombre</option>
                                    <option value="Mujer">Mujer</option>
                                    <option value="No Binario">No Binario</option>
                                    <option value="No definido">No definido</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Rázon de compra</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={purchase_reason}
                                    onChange={(e) => setValorSelect5(e.target.value)}>
                                    <option value="Sin respuesta">Sin respuesta</option>
                                    <option value="Vivir">Vivir</option>
                                    <option value="Renta">Renta</option>
                                    <option value="Inversion">Inversión</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Tiempo de compra</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={purchase_time}
                                    onChange={(e) => setValorSelect6(e.target.value)}>
                                    <option value="No estoy seguro">No estoy seguro</option>
                                    <option value="2 meses">Dos meses</option>
                                    <option value="Tres meses">Tres meses</option>
                                    <option value="Seis meses">Seis meses</option>
                                    <option value="Un año">Un año</option>
                                    <option value="null">No estoy seguro</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Presupuesto aproximado</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={budget}
                                    onChange={(e) => setValorSelect7(e.target.value)}>
                                    <option value="Sin respuesta">Sin respuesta</option>
                                    <option value="$400,000 a $490,000">$400,000 a $490,000</option>
                                    <option value="$500,000 a $780,000">$500,000 a $780,000</option>
                                    <option value="$790,000 a $890,000">$790,000 a $890,000</option>
                                    <option value="$$12,300,245">$12,300,245</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Forma de pago</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={payment_type}
                                    onChange={(e) => setValorSelect8(e.target.value)}>
                                    <option value="null">Sin respuesta</option>
                                    <option value="Contado Riguroso">Contado Riguroso</option>
                                    <option value="Contado Plazo">Contado Plazo</option>
                                    <option value="Crédito Infonavit">Crédito Infonavit</option>
                                    <option value="Crédito Bancario">Crédito Bancario</option>
                                    <option value="Fovissste">Fovissste</option>
                                    <option value="Fovissste Aliados">Fovissste Aliados</option>
                                    <option value="Fovissste Para Todos">Fovissste Para Todos</option>
                                    <option value="Infonavit Total">Infonavit Total</option>
                                    <option value="Apoyo Infonavit">Apoyo Infonavit</option>
                                    <option value="Cofinavit">Cofinavit</option>
                                    <option value="CFE">CFE</option>
                                    <option value="Telmex">Telmex</option>
                                    <option value="Cofinanciamiento">Cofinanciamiento</option>
                                    <option value="Crédito Interno">Crédito Interno</option>
                                    <option value="Cajas de Ahorro">Cajas de Ahorro</option>
                                    <option value="Otro">Otro</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Origen de prospecto</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={origin}
                                    onChange={(e) => setValorSelect9(e.target.value)}>
                                    <option></option>
                                    <optgroup label="Medios Digitales">
                                        <option value="Base_Datos">Base de Datos</option>
                                        <option value="Facebook">Facebook</option>
                                        <option value="Facebook_Desktop_Feed">Facebook Ads</option>
                                        <option value="Google">Google</option>
                                        <option value="Instagram">Instagram</option>
                                        <option value="Whatsapp">Whatsapp</option>
                                        <option value="Tiktok">Tiktok</option>
                                        <option value="Página web">Pagina web</option>
                                        <option value="Redes sociales">Redes sociales</option>
                                    </optgroup>
                                    <optgroup label="Medios Tradicionales">
                                        <option value="Broker">Broker o Asesor Externo</option>
                                        <option value="Cambaceo">Cambaceo</option>
                                        <option value="Contacto Directo">Contacto Directo</option>
                                        <option value="Espectacular">Espectacular</option>
                                        <option value="Inmobiliaria Externa">Inmobiliaria Externa</option>
                                        <option value="Lonas">Lonas</option>
                                        <option value="Periodico">Periodico</option>
                                        <option value="Radio">Radio</option>
                                        <option value="Recompra">Recompra</option>
                                        <option value="Revista">Revista</option>
                                        <option value="Referidos">Referidos</option>
                                        <option value="Señaletica">Señaletica</option>
                                        <option value="Telefono">Telefono</option>
                                        <option value="Televisión">Televisión</option>
                                        <option value="Volante">Volante</option>
                                        <option value="Walk-in">Walk-in</option>
                                    </optgroup>
                                    <optgroup label="Portales Inmobiliarios">
                                        <option value="Inmuebles 24">Inmuebles 24</option>
                                        <option value="Lamudi">Lamudi</option>
                                        <option value="Metros cúbicos">Metros cúbicos</option>
                                        <option value="Propiedades.com">Propiedades.com</option>
                                        <option value="Segundamano">Segundamano</option>
                                        <option value="Tu Hogar México">Tu Hogar México</option>
                                        <option value="Vivanuncios">Vivanuncios</option>
                                    </optgroup>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Medio de contacto</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={contact_type}
                                    onChange={(e) => setValorSelect10(e.target.value)}>
                                    <option value="null"></option>
                                    <option value="Teléfono">Teléfono</option>
                                    <option value="Correo">Correo</option>
                                    <option value="Whatsapp">Whatsapp</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Fecha de prospección</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <input type="date"
                                    disabled={!enModoEdicion}
                                    value={postulation_date}
                                    onChange={(e) => setValorInput2(e.target.value)} />
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Último contacto</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <label>{convertirFecha(dataLead ? dataLead.review_date : 'Cargando...')}</label>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Fecha de creación</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <label>{convertirFecha(dataLead ? dataLead.created_date : 'Cargando...')}</label>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Etiqueta</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <select style={estiloSelect} disabled={!enModoEdicion}
                                    value={tag}
                                    onChange={(e) => setValorSelect11(e.target.value)}>
                                    <option value="Seguimiento">Seguimiento</option>
                                    <option value="Llamar más adelante">Llamar más adelante</option>
                                    <option value="No contesta">No contesta</option>
                                    <option value="Apartado">Apartado</option>
                                    <option value="No comprará">No comprará</option>
                                    <option value="null">Sin etiqueta</option>
                                </select>
                            </div>
                            <div className="label-lead-perfilContacto-movil">
                                <label>Visitó desarrollo</label>
                            </div>
                            <div className="input-lead-perfilContacto-movil">
                                <input type="text"
                                    disabled={!enModoEdicion}
                                    value={formatDateToLongDate(visited_date) || 'Sin visita'}
                                    onChange={(e) => setValorInput3(e.target.value)} />
                            </div>
                        </div>
                        {enModoEdicion ? (
                            <div>
                                <div className="buttons-container-perfilContacto">
                                    <button className="btn-acept-modal" onClick={cancelarEdicion}>Guardar</button>
                                </div>
                            </div>
                        ) : (
                            <div className="buttons-container-perfilContacto">
                                <button className="btn-acept-modal" onClick={activarEdicion}>Editar perfil</button>
                            </div>
                        )}
                    </div>}
                    {seleccionado === "tareas" && <div className="info-margen-perfilContacto-movil">
                        <div className="button-container-tareas-movil">
                            <button onClick={openModalAddTarea}>
                                <img src={iconSvg} alt="+" />
                                <label>Añadir nueva tarea</label>
                            </button>
                        </div>
                        <div className="container-filtrosTask-movil">
                            <div className={`movil-tab ${activeTab === 'pendientes' ? 'active' : ''}`} onClick={() => setActiveTab('pendientes')}>
                                <label>Pendientes</label>
                            </div>
                            <div className={`movil-tab ${activeTab === 'finalizadas' ? 'active' : ''}`} onClick={() => setActiveTab('finalizadas')}>
                                <label>Finalizadas</label>
                            </div>
                        </div>
                        <div className="content-movil">
                            {activeTab === 'pendientes' && <div className="container-pendientes-movil">
                                {tasksOpen
                                    .map(task => (
                                        <div className="task-movil" onClick={() => openModalPendientTarea(task.id)} key={task.id}>
                                            <div className="task-container-column-movil">
                                                <div className="name-task-movil">
                                                    <label>{task.title}</label>
                                                </div>
                                                <div className="data-task-movil">
                                                    <label className="date-movil">{task.expiration}</label>
                                                    <label className="encargado-movil">{user}</label>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>}
                            {activeTab === 'finalizadas' && <div className="container-finalizadas-movil">
                                {tasksFinished
                                    .map(task => (
                                        <div className="task-movil" onClick={() => openModalFinishTarea(task.id)} key={task.id}>
                                            <div className="task-container-column-movil">
                                                <div className="name-task-movil">
                                                    <label>{task.title}</label>
                                                </div>
                                                <div className="data-task-movil">
                                                    <label className="date-movil">{task.expiration}</label>
                                                    <label className="encargado-movil">{user}</label>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>}
                        </div>
                    </div>}
                    {seleccionado === "contacto" && <div className="info-margen-perfilContacto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Intentos de contacto</label>
                        </div>
                        <div className="content-intentos-perfilContacto-movil">
                            <button onClick={openModalNota}>Crear nota</button>
                            {(intentos && Array.isArray(intentos) && intentos.length > 0) ? (intentos?.sort((a, b) => new Date(b.created) - new Date(a.created))
                                .map((item, index) => (
                                    <div className="nota-creada-movil" key={index}>
                                        <div className="nota-primeros-datos-movil">
                                            <img src={avatar} alt="avatar" />
                                            <label className="notas-user-movil">{userName}</label>
                                            <label className="notas-date-movil">{formatDateNotas(item.created)}</label>
                                        </div>
                                        <div className="nota-segundos-datos">
                                            <label className="notas-title-movil">{item.title}</label>
                                            <label className="notas-observation-movil">{item.observation}</label>
                                        </div>
                                    </div>
                                ))) : (
                                <p>* Por el momento no se puede obtener el historial de este prospecto.</p>
                            )}
                        </div>
                        <div className="button-contenedor-perfilContacto-movil">1 de 1</div>
                    </div>}
                    {seleccionado === "historial" && <div className="info-margen-perfilContacto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Historial de acciones</label>
                        </div>
                        {historial && historial?.sort((a, b) => new Date(b.created) - new Date(a.created))
                            .map((notes) => (
                                <div className="accion-history-info-perfilContacto-movil">
                                    <div className="main-history-info-perfilContacto-movil">
                                        <img src={avatar} alt="avatar" />
                                        <label>{userName}</label>
                                        <span>{formatDateNotas(notes.created)}</span>
                                    </div>
                                    <label id="dos">{notes.title}</label>
                                </div>
                            ))}
                    </div>}
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="title-modal-perfilContacto">
                    <div className="cabecera card2">
                        <div className="head-task-label">
                            <label>CREAR UNA TAREA</label>
                        </div>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Escribe un nombre para la tarea" />
                    </div>
                    <div className="card2-data-container">
                        <div className="cuadrado inicial">
                            <label>{user}</label>
                        </div>
                        <div className="container-data-asesor">
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="div2-textarea">
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción..."></textarea>
                    </div>
                    <div className="div2-btn">
                        <button className="addProyecto-btn" onClick={() => {
                            setTask_Status('Abierta')
                            handlePosthTasksByLeadRequest();
                            setTimeout(() => {
                                closeModal();
                            }, 1000);
                        }}>Crear tarea</button>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={isModalOpen2} onClose={closeModal2}>
                <div className="title-modal-perfilContacto">
                    <div className="cabecera card2">
                        <div className="head-task-label">
                            <button onClick={() => {
                                handleClickProceso()
                                setTimeout(() => {
                                    closeModal2();
                                }, 1000);
                            }}>
                                <img src={repeat} alt="repeat" class="imagen-estandar" />
                                <img src={repeat2} alt="repeat2" class="imagen-oculta" />
                                En proceso
                            </button>
                        </div>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}></input>
                    </div>
                    <div className="card2-data-container">
                        {nombre === null && setDataLead()}
                        {document.querySelectorAll('.cuadrado').forEach((element) => {
                            const text = element.textContent;
                            const firstLetter = document.createElement('span');
                            firstLetter.className = 'inicial';
                            firstLetter.textContent = text[0];
                            element.textContent = '';
                            element.appendChild(firstLetter);
                        })}
                        <div className="cuadrado inicial">
                            <label>{user}</label>
                        </div>
                        <div className="container-data-asesor">
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>{candidate_name}</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>{type_task}</label>
                        </button>
                    </div>
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="div2-btn">
                        <button className="addProyecto-btn" onClick={() => {
                            handlePatchTasksRequest();
                            setTimeout(() => {
                                closeModal2(task);
                            }, 1000);
                        }}>Editar tarea</button>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={isModalOpen3} onClose={closeModal3}>
                <div className="title-modal-perfilContacto">
                    <div className="cabecera card2">
                        <div className="head-task-label">
                            <button onClick={() => {
                                handleClickFinalizada()
                                setTimeout(() => {
                                    closeModal3(task);
                                }, 1000);
                            }} className="finish-task-btn">
                                <img src={checkmark} alt="checkmark" class="imagen-estandar" />
                                <img src={checkmark2} alt="checkmark2" class="imagen-oculta" />
                                Finalizada
                            </button>
                        </div>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}></input>
                    </div>
                    <div className="card2-data-container">
                        <div className="cuadrado inicial">
                            <label>{user}</label>
                        </div>
                        <div className="container-data-asesor">
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>{candidate_name}</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>{task ? task.type_task : null}</label>
                        </button>
                    </div>
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div className="div2-btn">
                        <button className="addProyecto-btn" onClick={() => {
                            handlePatchTasksRequest();
                            setTimeout(() => {
                                closeModal3();
                            }, 1000);
                        }}>Editar tarea</button>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={isModalOpen4} onClose={closeModal4}>
                <div className="modal-title">
                    <label>Descartar contacto</label>
                </div>
                <div className="container-descartar-modal-perfilContacto container-descartar-modal-perfilContacto-movil">
                    <div className="title-descartar-tab">
                        <label>Motivo:</label>
                        <span>Menciona porqué se descarta.</span>
                    </div>
                    <div className="options-descartar-tab">
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="No cumple con el perfil"
                                checked={newObservation === 'No cumple con el perfil'}
                                onChange={handleOpcionChange}
                            />
                            <label> No cumple con el perfil</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="No tiene interés"
                                checked={newObservation === 'No tiene interés'}
                                onChange={handleOpcionChange}
                            />
                            <label> No tiene interés</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="Número inválido"
                                checked={newObservation === 'Número inválido'}
                                onChange={handleOpcionChange}
                            />
                            <label> Número inválido</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="No contesta la llamada"
                                checked={newObservation === 'No contesta la llamada'}
                                onChange={handleOpcionChange}
                            />
                            <label> No contesta la llamada</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="Otra razón"
                                checked={newObservation === 'Otra razón'}
                                onChange={handleOpcionChange}
                            />
                            <label> Otra razón</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="Contacto repetido"
                                checked={newObservation === 'Contacto repetido'}
                                onChange={handleOpcionChange}
                            />
                            <label> Contacto repetido</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="El contacto es Broker"
                                checked={newObservation === 'El contacto es Broker'}
                                onChange={handleOpcionChange}
                            />
                            <label> El contacto es Broker</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="No cuenta con el presupuesto necesario"
                                checked={newObservation === 'No cuenta con el presupuesto necesario'}
                                onChange={handleOpcionChange}
                            />
                            <label> No cuenta con el presupuesto necesario</label>
                        </div>
                        <div className="item-descartar-tab">
                            <input
                                type="radio"
                                name="descarte"
                                value="Contacto falso"
                                checked={newObservation === 'Contacto falso'}
                                onChange={handleOpcionChange}
                            />
                            <label> Contacto falso</label>
                        </div>
                    </div>
                    <div className="buttons-container-modal">
                        <button className="btn-danger-modal" onClick={() => {
                            handlePatchDiscard()
                            setNewTitle('Descartado')
                            handleNotesCreate()
                            setTimeout(() => {
                                closeModal4();
                                navigate('/Contactos')
                            }, 1000);
                        }}>Descartar</button>
                        <button className="btn-cancel-modal" onClick={closeModal4} type="reset">Cancelar</button>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenPendientTarea} onClose={closeModalPendientTarea}>
                <div className="modal-title">
                    <div className="head-task-label">
                        <button onClick={() => {
                            handleClickProceso()
                            setTimeout(() => {
                                closeModalPendientTarea();
                            }, 1000);
                        }}>
                            <img src={repeat} alt="repeat" class="imagen-estandar" />
                            En proceso
                        </button>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}></input>
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>{user}</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>candidate</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>{type_task}</label>
                        </button>
                    </div>
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal" onClick={() => {
                        handlePatchTasksRequest();
                        setTimeout(() => {
                            closeModalPendientTarea(task);
                        }, 1000);
                    }}>Editar tarea</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenFinishTarea} onClose={closeModalFinishTarea}>
                <div className="modal-title">
                    <div className="head-task-label">
                        <button onClick={() => {
                            handleClickFinalizada()
                            setTimeout(() => {
                                closeModalFinishTarea(task);
                            }, 1000);
                        }} className="finish-task-btn">
                            <img src={checkmark} alt="checkmark" class="imagen-estandar" />
                            Finalizada
                        </button>
                    </div>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}></input>
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>{user}</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="buttons-prospects-tasks">
                        <button className="btn-prosp">
                            <img src={personTask} alt="personTask" />
                            <label>Prospecto</label>
                        </button>
                        <button className="btn-contac">
                            <img src={logoWhatsApp} alt="logoWhatsApp" />
                            <label>{type_task}</label>
                        </button>
                    </div>
                    <div className="div2-textarea">
                        <label>Descripción</label>
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button onClick={() => {
                        handlePatchTasksRequest();
                        setTimeout(() => {
                            closeModalFinishTarea();
                        }, 1000);
                    }} className="btn-acept-modal">Editar tarea</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenAddTarea} onClose={closeModalAddTarea}>
                <div className="modal-title">
                    <label>CREAR TAREA</label>
                </div>
                <div className="body-card2-task">
                    <div className="body-card2-task-input">
                        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Escribe un nombre para la tarea" />
                    </div>
                    <div className="card2-data-container">
                        <div className="container-data-asesor">
                            <div className="cuadrado inicial">
                                <label>{user}</label>
                            </div>
                            <div className="card2-data-asesor">
                                <label>Asignada a:</label>
                                <label>{nombreCompleto}</label>
                            </div>
                            <div className="card2-data-asesor-date">
                                <div className="card2-icon-calendar">
                                    <img src={img2} alt="calendar" />
                                </div>
                                <div className="date-data-div2">
                                    <label>Fecha de término:</label>
                                    <input type="date" value={expiration} onChange={handleDate2Change} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="div2-textarea">
                        <textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Descripción..."></textarea>
                    </div>
                </div>
                <div className="buttons-container-modal">
                    <button className="btn-acept-modal" onClick={() => {
                        setTask_Status('Abierta')
                        handlePosthTasksByLeadRequest();
                        setTimeout(() => {
                            closeModalAddTarea();
                        }, 1000);
                    }}>Crear tarea</button>
                </div>
            </Modal>
            <Modal isOpen={isModalOpenNota} onClose={closeModalNota}>
                <div className="modal-title">
                    <label>Crear nota</label>
                </div>
                <div className="container-main-modal intentos-perfilContacto-movil">
                    <label>Crea una nueva nota o alerta</label>
                    <input
                        placeholder="Titulo"
                        value={newTitle}
                        onChange={(e) => setNewTitle(e.target.value)}
                    />
                    <textarea
                        rows="4"
                        cols="40"
                        placeholder="Detalles de la nota..."
                        value={newObservation}
                        onChange={(e) => setNewObservation(e.target.value)}
                    ></textarea>
                    <button onClick={() => {
                        handleNotesCreate()
                        resetInputs()
                        setTimeout(() => {
                            closeModalNota();
                        }, 1000);
                    }}>Crear nota</button>
                </div>
            </Modal>
        </>
    )
}

export { PerfilContacto }